import React from 'react';
import CajaBusqueda from '../components/CajaBusqueda';

export default class Bienvenida extends React.Component {
    render() {
        return (
          <div className="ARC_Bienvenida">
            <img src={process.env.PUBLIC_URL + '/images/mireclu_Green.png'} alt=' ' />
            <br />
            <CajaBusqueda />
          </div>
        );
    }
}